import React from 'react';
import { makeStyles } from '@smile-next/uikit';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(7),
        width: '100%',
    },
}));

export const LoginFormBody: React.FC = (props) => {
    const classes = useStyles();
    return <div className={classes.root}>{props.children}</div>;
};
